import { inject, Injectable, NgZone } from '@angular/core';

import { from, Observable, of, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UnsavedChangesService {
    // #region Injects

    protected readonly ngZone = inject(NgZone);

    // #endregion

    // #region Properties

    private _nativeListener: EventListenerOrEventListenerObject | null;
    private _tracker: null | (() => Observable<boolean> | Promise<boolean> | boolean) = null;

    private _nativeChecker = (checker: any, event: any) => {
        const isClean = checker != null ? checker(true) : false;
        if (!isClean) {
            const msg = 'There may be unsaved changes on this page. Do you wish to continue leaving the page?';
            // tslint:disable-next-line: deprecation
            event = event || window.event;
            if (event) {
                event.returnValue = msg;
            }
            return msg;
        } else {
            return;
        }
        // tslint:disable-next-line: semicolon
    };

    // #endregion

    constructor() {
        this._nativeListener = null;
    }

    // #region Check Tracker Method

    checkTracker(): Observable<boolean> {
        if (this._tracker != null) {
            const result = this._tracker();
            let obsResult: Observable<boolean>;
            if (result instanceof Promise) {
                obsResult = from(result);
            } else if (!(result instanceof Observable)) {
                obsResult = of<boolean>(result).pipe(take(1));
            } else {
                obsResult = result as Observable<boolean>;
            }
            return obsResult.pipe(take(1));
        } else {
            return of<boolean>(true).pipe(take(1));
        }
    }

    // #endregion

    // #region Clear Tracking Method

    clearTracking(): void {
        if (this._nativeListener) {
            // Remove the event listener outside of Angular zone.
            this.ngZone.runOutsideAngular(() => {
                window.removeEventListener('beforeunload', this._nativeListener!);
                this._nativeListener = null;
            });
        }
        this._tracker = null;
    }

    // #endregion

    // #region Has Tracker

    hasTracker(): boolean {
        return this._tracker != null;
    }

    // #endregion

    // #region Set Tracking Method

    SetTracking(tracker: () => Observable<boolean> | Promise<boolean> | boolean): void {
        if (this._nativeListener) {
            this.clearTracking();
        }
        this._nativeListener = this._nativeChecker.bind(window, tracker);
        // Add event listener outside of the Angular zone.
        this.ngZone.runOutsideAngular(() => {
            window.addEventListener('beforeunload', this._nativeListener!);
            this._tracker = tracker;
        });
    }

    // #endregion
}
